import React from 'react';
import {
  Col,
} from 'reactstrap';
import { translate } from "react-translate";
import { useDroppable } from '@dnd-kit/core';

const Droppable = (props) => {
  const { isOver, setNodeRef } = useDroppable({
    id: 'droppable',
  });
  const style = {
    color: isOver ? 'green' : undefined,
  };

  return (
    <div ref={setNodeRef} className="droppable-zone" style={style}>
      {props.children}
    </div>
  );
}

const ReservedAssetList = (props) => {
  const { t, unreserveAsset, reservedAssets } = props;

  return (
    <Col>
      <small>{t("reserved-assets")}</small>
      <Droppable>
          <div>  
              {!reservedAssets.length ? "Drop in here" : reservedAssets.map(as => {
                  return (
                      <div 
                        key={`as-${as._id}`} 
                        onClick={() => {unreserveAsset(as._id)}}
                        className="assigned-asset"
                      >
                          {`${as.asset_type} \n (${as.brand} : ${as.serial_number})`}
                      </div>
                  )
              })}
          </div>
      </Droppable>
    </Col>
  );
};

export default translate("kits")(ReservedAssetList);
